/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { shortenandHoverString } from '../../../../Components/helper';
import { EditIcon } from '../../../../bombiix-icon';
import { NewSelectMultiSelect } from '../../../../Components/PIM/common/NewSelectMultiSelect';
import { useProductLandingPath } from '../../../../Components/CustomHooks/useProductLandingPath';

function ReorderTitleComponent({ reOrderList, item, activeDevId, reOrderOption, activeDropdown, activeSelectId, onBtnClick, handleLinkPage }) {
  const { t } = useTranslation('common');
  const productLandingPath = useProductLandingPath();
  if (reOrderList?.length > 0) {
    return (
      <div className="reorder-dropdown-container">
        <div className="flex-fill">
          <NewSelectMultiSelect
            options={reOrderOption}
            maxMenuHeight={138}
            menuPlacement="bottom"
            menuPosition="absolute"
            containerClassName="reorder-dropdown-select"
            getOptionLabel={(option) => `${option.number}`}
            getOptionValue={(option) => `${option._id}`}
            formatOptionLabel={(option) => (
              <span className="reorder-option-label" title={option.number}>
                {option.number}
              </span>
            )}
            onChange={(val) => onBtnClick(val)}
            value={activeDropdown}
          />
        </div>
        <span className="mr-16 ml-16 text-bold">+{item?.reOrders?.length}</span>
        <button type="button" aria-label={t('PRODUCT_LISTING.ACTION')} className="btn d-inline-flex p-0">
          <OverlayTrigger
            placement={t('TAKING_DATES.BUTTON')}
            trigger="click"
            rootClose
            overlay={
              <Popover className="custom-popover product-card-popover">
                <Popover.Content>
                  <ul>
                    <li>
                      <Link
                        className="cursor-pointer text-dark text-decoration-none"
                        to={productLandingPath(activeSelectId || activeDevId)}
                      >
                        {t('FILTER.TAKE_ME_TO_THIS_ORDER')}
                      </Link>
                    </li>
                    <li>
                      <a className="cursor-pointer text-dark text-decoration-none" onClick={handleLinkPage}>
                        {t('FILTER.VIEW_ALL_ORDERS')}
                      </a>
                    </li>
                  </ul>
                </Popover.Content>
              </Popover>
            }
          >
            <EditIcon size={24} className="reorder-edit-icon" />
          </OverlayTrigger>
        </button>
      </div>
    );
  }
  return (
    <Link className="title link-title bombiix-card__title" to={productLandingPath(item?._id)}>
      {shortenandHoverString(item?.number, 20)}
    </Link>
  );
}

export default ReorderTitleComponent;
